<template>
    <div>
        <div class="search-btn">
            <el-button size="small" type="primary" @click="scanCaseNode" v-if="$store.getters.checkChangeAuth()">
                扫描分层处理器
            </el-button>
        </div>

        <div v-if="info.success" class="device-case border-all">
            <el-table ref="multipleTable" :height="tableHeight" :data="info.list"
                      :header-cell-style="{backgroundColor: '#efefef'}" @row-click="goCaseDev" size="mini"
                      tooltip-effect="dark" style="width: 99%"
                      @selection-change="handleSelectionChange" :row-class-name="tableRowClassName">
                <el-table-column prop="caseNo" label="设备池编号"></el-table-column>
                <el-table-column label="机箱分区">
                    <template slot-scope="scope">
                        <span>{{scope.row.caseNo | showCaseLocation}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="deviceNum" label="设备数量"></el-table-column>
                <el-table-column prop="deviceNumIsDistributed" label="受控设备数量"></el-table-column>
                <el-table-column prop="deviceNumIsFault" label="故障设备数量"></el-table-column>
                <el-table-column prop="remark" label="备注"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <!--<el-button type="text" size="small" @click="goCaseDetail(scope.row)">管理</el-button>-->
                        <el-button type="text" size="small" @click.stop="goCaseDetail(scope.row)">详情</el-button>
                        <el-button type="text" size="small" @click.stop="scanDevice(scope.row.id)"
                                   v-if="$store.getters.checkChangeAuth()">扫描设备
                        </el-button>
                        <el-button type="text" size="small" @click.stop="deleteCase(scope.row.id)"
                                   v-if="$store.getters.checkChangeAuth()">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="list-bottom">
                <div></div>
                <el-pagination
                        @size-change="sizeChangeHandle"
                        @current-change="currentChangeHandle"
                        :current-page="page.startPage"
                        :page-sizes="[10, 20, 50]"
                        :page-size="page.limit"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next"
                        :total="info.total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "DeviceCase",
        data() {
            return {
                tableHeight: 0,
                info: {
                    success: false,
                    caseList: [],
                    total: 0
                },
                page: {
                    startPage: 1,
                    limit: 10
                },
                multipleSelection: []
            }
        },
        filters: {
            showCaseLocation(val) {
                if (val % 2 == 0) {
                    return val + '-右';
                } else {
                    return (parseInt(val) - 1) + '-左';
                }
            }
        },
        computed: {
            selectIds() {
                let list = []
                this.multipleSelection.forEach(v => {
                    list.push(v.id)
                })
                return list
            }
        },
        methods: {
            tableRowClassName({row, rowIndex}) {
                // console.log("rowIndex is " + rowIndex)
                if (rowIndex === 0) {
                    this.info.list[rowIndex].colorIndex = 1;
                    return 'success-row';
                } else {
                    if (parseInt(this.info.list[rowIndex].caseNo) === parseInt(this.info.list[rowIndex - 1].caseNo) + 1
                        || parseInt(this.info.list[rowIndex].caseNo) === parseInt(this.info.list[rowIndex - 1].caseNo) - 1) {
                        if (this.info.list[rowIndex - 1].colorIndex == 1) {
                            this.info.list[rowIndex].colorIndex = 1;
                            return 'success-row';
                        } else {
                            this.info.list[rowIndex].colorIndex = 0;
                            return 'warning-row';
                        }
                    } else {
                        if (this.info.list[rowIndex - 1].colorIndex == 1) {
                            this.info.list[rowIndex].colorIndex = 0;
                            return 'warning-row';
                        } else {
                            this.info.list[rowIndex].colorIndex = 1;
                            return 'success-row';
                        }
                    }
                }
            },
            /* 表单击行事件 */
            checkRow(r, c, e) {
                this.$refs.multipleTable.toggleRowSelection(r)
            },
            /* 获取设备池列表 */
            getDeviceCaseList() {
                this.$post(this.$uri.device.caseList, this.page).then(res => {
                    // console.log("res is ", JSON.stringify(res))
                    this.info = res
                    if (res.success) {
                        this.$nextTick().then(() => {
                            if (this.$refs.multipleTable) {
                                this.tableHeight = window.innerHeight - this.$refs.multipleTable.$el.offsetTop - 200;
                            }
                        })
                    }
                })
            },
            /* 当前页改变 */
            currentChangeHandle(val) {
                this.page.startPage = val
                this.getDeviceCaseList()
            },
            /* 每页条数改变 */
            sizeChangeHandle(val) {
                this.page.limit = val
                this.getDeviceCaseList()
            },
            /* 获取选中的数据 */
            handleSelectionChange(val) {
                this.multipleSelection = val
                // console.log(this.multipleSelection)
            },
            /* 扫描 */
            scan(uri, params) {
                let that = this
                that.$post(uri, params).then(res => {
                    that.$message.success("扫描成功")
                })
            },
            /* 扫描分层处理器 */
            scanCaseNode() {
                this.$confirm("确认扫描分层处理器？", "提示", {
                    confirmButtonText: '确定',
                    confirmButtonClass: 'confirm-btn-blue',
                    iconClass: 'el-icon-c-blue',
                    cancelButtonText: '取消'
                }).then(() => {
                    this.scan(this.$uri.device.scanNode, {})
                }).catch(() => {
                })
            },
            /* 扫描设备 */
            scanDevice(id) {
                this.$confirm("确认扫描设备？", "提示", {
                    confirmButtonText: '确定',
                    confirmButtonClass: 'confirm-btn-blue',
                    iconClass: 'el-icon-c-blue',
                    cancelButtonText: '取消'
                }).then(() => {
                    this.scan(this.$uri.device.scanDevice, {caseIds: [id]})
                }).catch(() => {
                })
            },
            /* 删除设备池 */
            deleteCase(id) {
                this.$confirm("删除设备池后会导致设备池内的设备恢复出厂设置，清除数据，是否继续？", "提示", {
                    confirmButtonText: '确定',
                    confirmButtonClass: 'confirm-btn-red',
                    iconClass: 'el-icon-c-red',
                    cancelButtonText: '取消'
                }).then(() => {
                    let that = this
                    that.$post(that.$uri.device.caseDelete, {id}).then(res => {
                        if (res.success) {
                            setTimeout(() => {
                                that.getDeviceCaseList()
                            }, 1000)
                        } else {
                            that.$message.error("删除失败")
                        }
                    })

                }).catch(() => {
                })
            },
            /* 查看设备池详情 */
            goCaseDetail(info) {
                this.$store.dispatch(this.$action.GO_CASE_DETAIL, info)
            },
            /* 查看设备列表 */
            goCaseDev(info) {
                this.$store.dispatch(this.$action.GO_CASE_DEV, info)
            }
        },
        mounted() {
            this.getDeviceCaseList()
        }
    };
</script>

<style lang="less">
    .device-case {
        .list-bottom {
            padding: 10px 8px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
        }
    }

    .el-table .warning-row {
        background: #f9f9f9;
    }

    .el-table .success-row {
        background: white;
    }
</style>